import {
  BarChart, Bar, LineChart, Line,
  XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid,
} from 'recharts';
import type { ChartSpec } from '../lib/types.ts';

interface Props {
  spec: ChartSpec;
  height?: number;
}

export function ChartRenderer({ spec, height = 300 }: Props) {
  if (!spec.viable || !spec.data_points?.length) {
    return <p style={{ color: '#999', fontStyle: 'italic' }}>No chart data available.</p>;
  }

  const data = spec.data_points.map(pt => ({ name: pt.label, value: pt.value }));

  const chart = spec.type === 'line' ? (
    <LineChart data={data}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="name" tick={{ fontSize: 11 }} />
      <YAxis tick={{ fontSize: 11 }} />
      <Tooltip />
      <Line type="monotone" dataKey="value" stroke="#1a6aff" strokeWidth={2} dot={false} />
    </LineChart>
  ) : (
    <BarChart data={data}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="name" tick={{ fontSize: 11 }} />
      <YAxis tick={{ fontSize: 11 }} />
      <Tooltip />
      <Bar dataKey="value" fill="#1a6aff" />
    </BarChart>
  );

  return (
    <div>
      <p style={{ margin: '0 0 4px', fontSize: 13, fontWeight: 600, color: '#333' }}>{spec.title}</p>
      <ResponsiveContainer width="100%" height={height}>
        {chart}
      </ResponsiveContainer>
      {spec.insight && (
        <p style={{ margin: '8px 0 0', fontSize: 12, color: '#666', fontStyle: 'italic' }}>{spec.insight}</p>
      )}
    </div>
  );
}
